//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionError from "./section-error";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RadioSection",
  components: {
    SectionError
  },
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    path: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    checked: {
      type: null,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelFromName: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    translationMap: {
      type: Object,
      default: null
    },
    containerClass: {
      type: String,
      default: ""
    },
    optionClass: {
      type: String,
      default: ""
    },
    stopPropagation: {
      type: Boolean,
      default: false
    },
    noIdentation: {
      type: Boolean,
      default: false
    },
    emitChangeOnClick: {
      type: Boolean,
      default: true
    },
    horizontalStyle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputName() {
      return `${this.path}[${this.name}]`;
    }
  },
  methods: {
    radioId(value) {
      return `${this.path}[${this.name}]-${value}`;
    },
    handleInput(event) {
      const {
        target
      } = event;
      if (this.stopPropagation) event.stopPropagation();
      let value = target.value;
      if (value === "true") {
        value = true;
      }
      if (value === "false") {
        value = false;
      }
      this.$emit("change", value);
    },
    handleClick() {
      if (this.emitChangeOnClick) this.$emit("change", "");
    },
    log(val) {
      //eslint-disable-next-line no-console
      console.log(val);
    }
  }
});